var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-return",on:{"click":_vm.click}},[_c('i',{staticClass:"el-icon-arrow-left icon-r"})])}
var staticRenderFns = []

export { render, staticRenderFns }